var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/login/form-buttons.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n\n";
if(!runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += "\n\n    <div class=\"g-modal-login__submit\">\n\n        <button type=\"submit\" class=\"c-button-primary c-button-primary--full\" data-qa-login-submit>\n            ";
output += runtime.suppressValue((lineno = 8, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_sign-in-submit"])), env.opts.autoescape);
output += "\n        </button>\n\n    </div>\n\n    <div class=\"g-modal-login__cancel\">\n\n            <div class=\"c-modal-form__field c-modal-login__button-cancel\">\n\n                <button class=\"c-button-text c-modal-form__cancel js-modal__cancel\" data-qa-login-close>\n                    ";
output += runtime.suppressValue((lineno = 18, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_cancel"])), env.opts.autoescape);
output += "\n                </button>\n\n            </div>\n\n    </div>\n\n";
;
}
else {
output += "\n\n    <div class=\"o-row o-column o-extra-small--12 o-small--12\">\n\n        <button class=\"c-button-primary c-button-primary--full\" type=\"submit\" data-qa-login-submit>\n            ";
output += runtime.suppressValue((lineno = 30, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_sign-in-submit",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n        </button>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/login/form-buttons.j2"] , dependencies)